import {observer} from "mobx-react"
import {useRootStore} from "store/useRootStore"
import {useFindAllCategories} from "hooks/queries/category.query"
import {useEffect, useState} from "react"
import {Category} from "dto/category/category"
import {calculateDeviceStatus, Counter, newCounter} from "store/dashboard/DashboardStore"
import {isEmergencyStatus, isErrorStatus, isNoneOperationStatus, RealDevice} from "dto/realdevice/devices"
import TtlDeviceStatusCounterPanel from "pages/dashboard/ttl-status/TtlDeviceStatusCounterPanel"
import DeviceStatusSummaryCard from "pages/dashboard/ttl-status/DeviceStatusSummaryCard"
import {useQuery} from "react-query"
import {RealDeviceApi} from "api/real-device"

const useFindAllDevices = () => {
    return useQuery("real-device/list/status", async () => {
        const result = await RealDeviceApi.findAll()
        return result?.data?.body || []
    })
}
type Props = {
    allCategories: Category[]
    devices: RealDevice[]
    onSelectCategory: (category: Category) => void
}
const TopLevelDeviceStatusView = observer(({allCategories, devices, onSelectCategory}: Props) => {
    const {dashboardStore: {showTtlDeviceStatus, setShowTtlDeviceStatus}} = useRootStore()
    // const devices = useFindAllDevices()?.data || []
    // const allCategories = useFindAllCategories()?.data

    const [parentCategoryMap, setParentCategoryMap] = useState<Map<number, Category>>(new Map())
    const [childCategoryMap, setChildCategoryMap] = useState<Map<number, Category>>()
    const [parentFinderMap, setParentFinderMap] = useState<Map<number, number>>(new Map())
    const [parentStatusMap, setParentStatusMap] = useState<Map<number, Counter>>(new Map())
    const {dashboardStore: {counter}} = useRootStore()

    useEffect(() => {
        if (!allCategories) return
        const parentCategoryMap = new Map<number, Category>()
        const childCategoryMap = new Map<number, Category>()
        const parentFinderMap = new Map<number, number>()
        allCategories
            .forEach((category: Category) => {
                if (!category.id) return
                if (category.level === "CITY") {
                    parentCategoryMap.set(category.id, category)
                } else if (category.level === "DISTRICT") {
                    if (category.parentId) {
                        parentFinderMap.set(category.id, category.parentId)
                    }
                    childCategoryMap.set(category.id, category)
                }
            })
        setParentCategoryMap(parentCategoryMap)
        setParentFinderMap(parentFinderMap)
        setChildCategoryMap(childCategoryMap)
    }, [allCategories])

    useEffect(() => {
        const parentStatusMap = new Map<number, Counter>()
        devices.forEach((device) => {
            if (device.category?.id) {
                const parentId = parentFinderMap.get(device.category.id)
                if (parentId) {
                    const parentStatus = parentStatusMap.get(parentId) || newCounter()

                    parentStatus.ttlCount = parentStatus.ttlCount + 1
                    calculateDeviceStatus(device, counter)

                    parentStatusMap.set(parentId, parentStatus)
                }
            }
            setParentStatusMap(parentStatusMap)
        })
    }, [devices, parentCategoryMap])
    if (!showTtlDeviceStatus) return null

    return (
        <div className="column body-operation" style={{height: '90%'}}>
            <div>
                <h1 className="title has-text-info ml10 mt10">
                    <span className="has-text-warning is-size-2">전동 휠체어 </span>
                    <span className="ml5">지역(카테고리)별 장비현황 </span>
                </h1>
            </div>
            <div className="columns is-variable bd-klmn-columns is-5 mt10 p10">
                <TtlDeviceStatusCounterPanel counter={counter}/>
            </div>
            <div className="columns is-variable bd-klmn-columns is-5 p10 is-multiline">
                {Array.from(parentCategoryMap.values()).map((category: Category) => {
                    const areaCounter = parentStatusMap.get(category.id || 0) || newCounter()
                    console.log("area counter : ", areaCounter)
                    return <DeviceStatusSummaryCard key={category.id} label={category.name} counter={areaCounter}
                                                    onClick={() => onSelectCategory(category)}
                    />
                })}
            </div>
        </div>
    )
})

export default TopLevelDeviceStatusView